import { Controller } from "@hotwired/stimulus";

const WARNING_THRESHOLD = 0.9;

export default class extends Controller {
  static targets = ["slider", "display", "description", "warning", "warningText"];
  static values = {
    riskDescription: String,
    riskMinimal: String,
    riskVerySmall: String,
    riskSmall: String,
    riskLarge: String,
    riskVeryLarge: String,
    warning: String,
  };
  static classes = ["hidden"];

  connect() {
    this.update();
  }

  update() {
    const value = parseFloat(this.sliderTarget.value);
    const percentage = Math.round(value * 100);
    this.displayTarget.textContent = `${percentage}%`;

    const min = parseFloat(this.sliderTarget.min);
    const max = parseFloat(this.sliderTarget.max);
    const position = ((value - min) / (max - min)) * 100;
    this.displayTarget.style.left = `calc(${position}% - 15px)`;

    const riskPercentage = 100 - percentage;
    const riskLevel = this.getRiskLevel(riskPercentage);
    this.descriptionTarget.innerHTML = this.riskDescriptionValue
      .replace("%{percentage}", percentage)
      .replace("%{risk_percentage}", riskPercentage)
      .replace("%{risk_level}", riskLevel);

    this.warningTarget.classList.toggle("hidden", value >= WARNING_THRESHOLD);
    this.warningTextTarget.textContent = this.warningValue;
  }

  getRiskLevel(riskPercentage) {
    if (riskPercentage >= 30) return this.riskVeryLargeValue;
    if (riskPercentage >= 20) return this.riskLargeValue;
    if (riskPercentage >= 5) return this.riskSmallValue;
    if (riskPercentage >= 2) return this.riskVerySmallValue;
    return this.riskMinimalValue;
  }
}
